module.exports = __webpack_public_path__ + "static/media/diprospero.e3b29099.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/tizon_tardio_tomate/curativa/diprospero.png
// module id = 2396
// module chunks = 3